<main class="body-main d-none">
  <section class="log-in">
    <div class="container">
      <div class="row">
        <div class="col-lg-7">
          <div class="login-left" style="
              background-image: url('./assets/images/login/login-left-back.png');
            ">
            <h1>Vivamus pellentesque urna eu eros blandit</h1>
            <img src="assets/images/login/login-left.png" alt="" class="img-fluid" />
          </div>
        </div>
        <div class="col-lg-5">
          <div class="login-right">
            <h4>Syncinns</h4>
            <h6>Enter The Verification Code</h6>
            <p>Please enter the verification code sent to your email</p>
            <div class="login-form">
              <form (ngSubmit)="verifyOtp()" [formGroup]="otpForm">
                <div class="row form-rw reset-rw">
                  <div class="col-3 login-form-input reset-col">
                    <input type="text" class="px-2 otp-input" type="text" id="otp1" maxlength="1" formControlName="otp1"
                      (input)="onInput($event, 'otp2')" (paste)="onPaste($event)"
                      (keydown)="onKeyDown($event, 'otp1', '')" [autofocus]="true" [class.is-invalid]="
                        otpForm.controls['otp1'].invalid &&
                        otpForm.controls['otp1'].touched
                      " />
                  </div>
                  <div class="col-3 login-form-input reset-col">
                    <input type="text" class="px-2 otp-input" maxlength="1" formControlName="otp2" id="otp2"
                      class="otp-input" (input)="onInput($event, 'otp3')" (paste)="onPaste($event)"
                      (keydown)="onKeyDown($event, 'otp2', 'otp1')" [class.is-invalid]="
                        otpForm.controls['otp2'].invalid &&
                        otpForm.controls['otp2'].touched
                      " />
                  </div>
                  <div class="col-3 login-form-input reset-col">
                    <input type="text" class="px-2 otp-input" maxlength="1" formControlName="otp3" id="otp3"
                      class="otp-input" (input)="onInput($event, 'otp4')" (paste)="onPaste($event)"
                      (keydown)="onKeyDown($event, 'otp3', 'otp2')" [class.is-invalid]="
                        otpForm.controls['otp3'].invalid &&
                        otpForm.controls['otp3'].touched
                      " />
                  </div>
                  <div class="col-3 login-form-input reset-col">
                    <input type="text" class="px-2 otp-input" maxlength="1" formControlName="otp4" id="otp4"
                      class="otp-input" (input)="onInput($event, '')" (paste)="onPaste($event)"
                      (keydown)="onKeyDown($event, 'otp4', 'otp3')" [class.is-invalid]="
                        otpForm.controls['otp4'].invalid &&
                        otpForm.controls['otp4'].touched
                      " />
                  </div>
                </div>
                @if (otpForm.invalid && otpForm.touched ) {
                <div class="text-danger mt-2">
                  Please enter all 4 digits of the OTP.
                </div>
                }
                <div class="row">
                  <div class="col-12">
                    <!-- <input type="submit" value="verify"> -->
                    <button class="login-cmn-button" [disabled]="otpForm.invalid">
                      verify
                    </button>
                  </div>
                </div>
              </form>
              <div class="social-list">
                <ul>
                  <li>
                    <a href="https://www.linkedin.com/company/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/linkdin.png" alt="LinkedIn" />
                    </a>
                  </li>
                  <li>
                    <a href="https://x.com/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/devicontwitter.png" alt="Twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/facebook.png" alt="Facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/syncinns/" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/instragram.png" alt="Instagram" />
                    </a>
                  </li>
                </ul>
              </div>
              <p>Remember password? <a href="/login">Sign In</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<section class="common-login-section">
  <div class="imgtexture">
    <div class="imginfobox">
      <img src="assets/images/login/texture.png" alt="" />
      <img src="assets/images/login/texture.png" alt="" />
    </div>
  </div>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12 col-12">
        <div class="tpfLoginContainer">
          <h2 class="tpfLoginTitle">{{ 'forgotPassword.otpVerification' | translate}}</h2>
          <p class="tpfLoginSub">
            {{'forgotPassword.otpVerificationSubtext' | translate}}
          </p>
          <div class="login-form">
            <form (ngSubmit)="verifyOtp()" [formGroup]="otpForm">
              <div class="tpfInputGroup-main">
                <div class="tpfInputGroup">
                  <!-- <label>Email</label> -->
                  <input type="text" class="px-2 otp-input" type="text" id="otp1" maxlength="1" formControlName="otp1"
                    (input)="onInput($event, 'otp2')" (paste)="onPaste($event)"
                    (keydown)="onKeyDown($event, 'otp1', '')" [autofocus]="true" [class.is-invalid]="
                      otpForm.controls['otp1'].invalid &&
                      otpForm.controls['otp1'].touched
                    " />
                </div>
                <div class="tpfInputGroup">
                  <input type="text" class="px-2 otp-input" maxlength="1" formControlName="otp2" id="otp2"
                    class="otp-input" (input)="onInput($event, 'otp3')" (paste)="onPaste($event)"
                    (keydown)="onKeyDown($event, 'otp2', 'otp1')" [class.is-invalid]="
                      otpForm.controls['otp2'].invalid &&
                      otpForm.controls['otp2'].touched
                    " />
                </div>
                <div class="tpfInputGroup">
                  <input type="text" class="px-2 otp-input" maxlength="1" formControlName="otp3" id="otp3"
                    class="otp-input" (input)="onInput($event, 'otp4')" (paste)="onPaste($event)"
                    (keydown)="onKeyDown($event, 'otp3', 'otp2')" [class.is-invalid]="
                      otpForm.controls['otp3'].invalid &&
                      otpForm.controls['otp3'].touched
                    " />
                </div>
                <div class="tpfInputGroup">
                  <input type="text" class="px-2 otp-input" maxlength="1" formControlName="otp4" id="otp4"
                    class="otp-input" (input)="onInput($event, '')" (paste)="onPaste($event)"
                    (keydown)="onKeyDown($event, 'otp4', 'otp3')" [class.is-invalid]="
                      otpForm.controls['otp4'].invalid &&
                      otpForm.controls['otp4'].touched
                    " />
                </div>
              </div>
              <div class="tpfInputGroup">
                @if (otpForm.invalid && otpForm.touched ) {
                <div class="invalid-feedback d-block">
                 {{ 'forgotPassword.enterAllOtpDigits' | translate}}
                </div>
                }
              </div>
              <div class="tpfInputGroup">
                @if (!isOtpExpired) {
                <p class="mb-2">{{ 'forgotPassword.otpExpiresIn' | translate }} <strong>{{ formattedTime }}</strong></p>
                } @else {
                <p class="mb-2 text-danger">{{ 'forgotPassword.otpExpired' | translate }}</p>
                }
                <button type="button" class="btn btn-link p-0" (click)="resendOtp()"
                  [disabled]="!canResend || isResending">
                  {{ isResending ? this.translate.instant('forgotPassword.sending')   : this.translate.instant('forgotPassword.resendOtp')  }}
                </button>
              </div>
              <div class="BOTTOMINFO">
                <div class="col-lg-12">
                  <button class="tpfLoginBtn" [disabled]="otpForm.invalid || isOtpExpired">
                    {{ 'forgotPassword.verify' | translate }}
                  </button>
                </div>
              </div>

              <div class="tpfLineWrap">
                <span><b>{{ 'forgotPassword.followLabel' | translate }}</b>{{ 'forgotPassword.followText' | translate }}</span>
              </div>

              <div class="social-listnew">
                <ul class="tpfSocialRow">
                  <li class="tpfSocial">
                    <a href="https://www.linkedin.com/company/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/linkdin.png" alt="LinkedIn" />
                    </a>
                  </li>
                  <li class="tpfSocial">
                    <a href="https://x.com/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/devicontwitter.png" alt="Twitter" />
                    </a>
                  </li>
                  <li class="tpfSocial">
                    <a href="https://www.facebook.com/syncinns" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/facebook.png" alt="Facebook" />
                    </a>
                  </li>
                  <li class="tpfSocial">
                    <a href="https://www.instagram.com/syncinns/" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/login/instragram.png" alt="Instagram" />
                    </a>
                  </li>
                </ul>
              </div>
              <p>{{ 'forgotPassword.rememberPassword' | translate }} <a href="/login">{{ 'forgotPassword.signIn' | translate }}</a></p>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-12 hidebox">
        <div class="new-colortexturebox">
          <img src="assets/images/login/newtexture.png" alt="" />
        </div>
        <div class="sync-banner-container">
          <div class="sync-slider-wrapper">
            <div class="abanimation">
              <img src="assets/images/login/thunderbolt.png" alt="" />
            </div>
            <div class="sync-slider">
              <!-- Slide 1 -->
              <div class="sync-slide">
                <div class="sync-banner-card">
                  <div class="sync-left">
                    <div class="sync-logo">
                      <img src="assets/images/login/logo.png" alt="" />
                    </div>
                    <h2>{{ 'forgotPassword.smartAnalytics' | translate }}</h2>
                    <ul>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.roomOccupancyReports' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                       {{ 'forgotPassword.roleBasedUserPermissions' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.enterpriseGradeSecurity' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.pricingAndRentalInvoices' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.housekeepingAutomation' | translate }}
                      </li>
                    </ul>
                  </div>
                  <div class="sync-right">
                    <img src="assets/images/login/slide1.png" alt="" />
                  </div>
                </div>
              </div>

              <!-- Slide 2 -->
              <div class="sync-slide">
                <div class="sync-banner-card">
                  <div class="sync-left">
                    <div class="sync-logo">
                      <img src="assets/images/login/logo.png" alt="" />
                    </div>
                    <h2>{{ 'forgotPassword.carRentalManagement' | translate}}</h2>
                    <ul>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.vehicleAvailabilityTracking' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.driverAssignment'| translate  }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.gpsAndTripLogs' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                       {{'forgotPassword.pricingAndRentalInvoices' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{'forgotPassword.fleetMaintenanceReminders' | translate}}
                      </li>
                    </ul>
                  </div>
                  <div class="sync-right">
                    <img src="assets/images/login/slide2.png" alt="" />
                  </div>
                </div>
              </div>

              <!-- Slide 3 -->
              <div class="sync-slide">
                <div class="sync-banner-card">
                  <div class="sync-left">
                    <div class="sync-logo">
                      <img src="assets/images/login/logo.png" alt="" />
                    </div>
                    <h2>{{ 'forgotPassword.whySyncinns' | translate }}</h2>
                    <ul>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.hotelRoomBookingsAndOccupancy' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.guestManagementAndCrm' | translate }}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                       {{ 'forgotPassword.multiPropertyOperations' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.analyticsAndBusinessInsights' | translate}}
                      </li>
                      <li>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.29039 21.5808C14.4213 21.5808 18.5808 17.4213 18.5808 12.2904C18.5808 7.15945 14.4213 3 9.29039 3C4.15945 3 0 7.15945 0 12.2904C0 17.4213 4.15945 21.5808 9.29039 21.5808Z"
                            fill="#B0EF8F" />
                          <path
                            d="M9.39547 19.4711L9.27763 19.2703C7.47766 16.2035 2.69446 9.69527 2.64615 9.62991L2.57715 9.53617L4.20676 7.92567L9.36521 11.5277C12.6131 7.31305 15.6432 4.41825 17.6197 2.7278C19.7818 0.878618 21.1892 0.0273155 21.2034 0.0191577L21.2354 0H23.9997L23.7356 0.235154C16.9447 6.2838 9.5841 19.1396 9.51078 19.2688L9.39547 19.4711Z"
                            fill="#009045" />
                        </svg>
                        {{ 'forgotPassword.housekeepingAutomation' | translate}}
                      </li>
                    </ul>
                  </div>
                  <div class="sync-right">
                    <img src="assets/images/login/slide3.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>